import { Component, Input } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { VehiclesService } from "../vehicles.service";

@Component({
  selector: "app-view-vehicle",
  templateUrl: "./view-vehicle.component.html",
  styleUrls: ["./view-vehicle.component.sass"],
})
export class ViewVehicleComponent {
  @Input() vehicleData: any = null;

  vehicleForm: FormGroup;
  showModal = false;
  newMinCapacity = "";
  newMaxCapacity = "";

  constructor(
    private fb: FormBuilder,
    private vehiclesService: VehiclesService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {
    this.vehicleForm = this.fb.group({
      truckType: [""],
      image: [""],
      vehicleLength: [""],
      vehicleBreadth: [""],
      vehicleHeight: [""],
      truckTyres: [""],
    });
  }

  open(vehicle: any = null) {
    this.vehicleData = vehicle;
    if (vehicle) {
      this.vehicleForm.patchValue({
        truckType: vehicle.truckType || "",
        image: vehicle.image || "",
        vehicleLength: vehicle.vehicleLength || "",
        vehicleBreadth: vehicle.vehicleBreadth || "",
        vehicleHeight: vehicle.vehicleHeight || "",
        truckTyres: vehicle.truckTyres || "",
      });
      this.getTruckTons();
    }
    this.showModal = true;
  }

  close() {
    this.showModal = false;
  }

  availableTons: [];
  getTruckTons() {
    this.spinner.show();
    let data = { truckId: this.vehicleData._id };

    this.vehiclesService.getTruckTons(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        console.log("get all tons ", result);
        this.availableTons = result.data;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  addTon() {
    this.spinner.show();
    let data = {
      minCapacity: this.newMinCapacity,
      maxCapacity: this.newMaxCapacity,
      truckId: this.vehicleData._id,
    };
    console.log(data);
    this.vehiclesService.addTons(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        console.log("addton ", result);
        this.newMinCapacity = "";
        this.newMaxCapacity = "";
        this.getTruckTons();
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  editTon(data: any) {
    this.spinner.show();
    let tonId = data._id;
    let reqData = {
      minCapacity: data.minCapacity,
      maxCapacity: data.maxCapacity,
    };
    console.log("editreq", reqData)
    this.vehiclesService.updateTons(tonId, reqData).subscribe((result: any) => {
      if (result.statusCode == 200) {
        console.log("addton ", result);
        this.getTruckTons();
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  deleteTon(id: string) {
    this.vehiclesService.deleteTons(id).subscribe((result: any) => {
      if (result.statusCode == 200) {
        console.log("addton ", result);
        this.toastr.success(result.message);
        this.getTruckTons();
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }
}
